import Navbar from "layouts/Navbar";
import React from "react";
import { useRouteError } from "react-router-dom";
import Lottie from "lottie-react";
import errorAnimation from "../../assets/json/error.json";

const PageError = ({ not404 }) => {
  const error = useRouteError();

  // const handlerReload = (e) => {
  //   window.location.reload();
  // };

  const handlerGoBack = (e) => {
    window.history.back();
  };

  if (not404) {
    return (
      <>
        <Navbar />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "80vh" }}
        >
          <div className="text-center">
            <Lottie
              style={{ width: "50%", height: "50%", margin: "0 auto" }}
              animationData={errorAnimation}
              loop={true}
            />
            <h5 className="fw-bold">Internal Server Error</h5>
            <p>{error.message}</p>
            <button
              className="btn btn-cta rounded-5 checkout-button mt-3"
              onClick={handlerGoBack}
            >
              Coba Lagi
            </button>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Navbar />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "80vh" }}
        >
          <div className="text-center">
            <h5 className="fw-bold">{error.status}</h5>
            <p className="mb-0">{error.statusText}</p>
          </div>
        </div>
      </>
    );
  }
};

export default PageError;
